<template>
  <div>
    <Button
      :size="15"
      color="#33BDFF"
      colorText="#ffffff"
      tooltip="Reemplazar"
      icon="fas fa-exchange-alt"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      translate
      @click.native="showModalValidation();"
    />
    <ui-modal
      ref="modal"
      size="small"
      class="modal-buscar-reemplazar-acuerdos-lineas"
      title="Buscar y Reemplazar"
      @close="ActionSetZindexModal(false)"
    >
      <!-- Cuerpo -->
      <div>
        <!-- Campo en donde buscar -->
        <div class="d-flex">
          <ui-select
            label="Campo en donde Buscar :"
            class="w-100 mr-2 mt-3"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccione"
            :options="listaCampos"
            @change="changeFormatField();"
            v-model="dataCampoParaBuscar"
          ></ui-select>
        </div>
        <!-- Valor a buscar  -->
        <div v-if="dataCampoParaBuscar.id === undefined   || dataCampoParaBuscar.id === 'transit_time' || 
            dataCampoParaBuscar.id === 'neta'             || dataCampoParaBuscar.id === 'public_value'     ||
            dataCampoParaBuscar.id === 'free_days_land'   || dataCampoParaBuscar.id === 'plug_days_land'   ||
            dataCampoParaBuscar.id === 'free_days_embark' || dataCampoParaBuscar.id === 'plug_days_embark' ||
            dataCampoParaBuscar.id === 'comment'">
          <ui-textbox
            label="Valor a Buscar :"
            class="w-100 mt-3"
            v-model="dataValorCampo"
          ></ui-textbox>
        </div>

        <div v-if="dataCampoParaBuscar.id === 'from_date' || dataCampoParaBuscar.id === 'to_date' " >

          <date-picker
            class="w-100 datepicker-custom mt-4"
            placeholder="Valor a Buscar :"
            type="date"
            value-type="format"
            @close="handleOpenChange"
            v-model="dataValorCampo"
          />
        </div>

        <div v-if="dataCampoParaBuscar.id === 'products_category_id'" >

          <ui-select
            label="Valor a Buscar :"
            class="w-100 mt-3"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccione"
            :options="selectCommodities"
            v-model="dataValorCampo"
          ></ui-select>
        </div>


        <div v-if="dataCampoParaBuscar.id === 'container_id' ">
          <ui-select
            label="Valor a Buscar :"
            class="w-100 mt-3"
            :keys="{ value: 'id', label: 'code' }"
            placeholder="Seleccione"
            :options="selectContainers"
            v-model="dataValorCampo"
          ></ui-select>
        </div>

        <div v-if="dataCampoParaBuscar.id === 'atmosphere_id' ">
          <ui-select
            label="Valor a Buscar :"
            class="w-100 mt-3"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccione"
            :options="selectAtmospheres"
            v-model="dataValorCampo"
          ></ui-select>
        </div>

        <div v-if="dataCampoParaBuscar.id === 'coldtreatment_id' ">
          <ui-select
            label="Valor a Buscar :"
            class="w-100 mt-3"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccione"
            :options="selectColdtreatment"
            v-model="dataValorCampo"
          ></ui-select>
        </div>

        <div v-if="dataCampoParaBuscar.id === 'tariff_contract_id'">
          <ui-select
            label="Valor a Buscar :"
            class="w-100 mt-3"
            :keys="{ value: 'id', label: 'name' }"
            placeholder="Seleccione"
            :options="selectedContractsList"
            v-model="dataValorCampo"
          ></ui-select>
        </div>
      </div>

      <!-- Valor a reemplazar -->

      <div v-if="dataCampoParaBuscar.id === undefined   || dataCampoParaBuscar.id === 'transit_time' || 
          dataCampoParaBuscar.id === 'neta'             || dataCampoParaBuscar.id === 'public_value'     ||
          dataCampoParaBuscar.id === 'free_days_land'   || dataCampoParaBuscar.id === 'plug_days_land'   ||
          dataCampoParaBuscar.id === 'free_days_embark' || dataCampoParaBuscar.id === 'plug_days_embark' ||
          dataCampoParaBuscar.id === 'comment'">
        <ui-textbox
          label="Valor a Reemplazar :"
          class="w-100 mt-3"
          v-model="dataValorReemplazar"
        ></ui-textbox>
      </div>

      <div v-if="dataCampoParaBuscar.id === 'from_date' || dataCampoParaBuscar.id === 'to_date' " >
        <date-picker
          class="w-100 datepicker-custom mt-5"
          placeholder="Valor a Reemplazar :"
          type="date"
          value-type="format"
          @close="handleOpenChange"
          v-model="dataValorReemplazar"
        />
      </div>

      <div v-if="dataCampoParaBuscar.id === 'products_category_id'" >

        <ui-select
          label="Valor a Reemplazar :"
          class="w-100 mt-3"
          :keys="{ value: 'id', label: 'name' }"
          placeholder="Seleccione"
          :options="selectCommodities"
          v-model="dataValorReemplazar"
        ></ui-select>
      </div>


      <div v-if="dataCampoParaBuscar.id === 'container_id' ">
        <ui-select
          label="Valor a Reemplazar :"
          class="w-100 mt-3"
          :keys="{ value: 'id', label: 'code' }"
          placeholder="Seleccione"
          :options="selectContainers"
          v-model="dataValorReemplazar"
        ></ui-select>
      </div>

      <div v-if="dataCampoParaBuscar.id === 'atmosphere_id' ">
        <ui-select
          label="Valor a Reemplazar :"
          class="w-100 mt-3"
          :keys="{ value: 'id', label: 'name' }"
          placeholder="Seleccione"
          :options="selectAtmospheres"
          v-model="dataValorReemplazar"
        ></ui-select>
      </div>

      <div v-if="dataCampoParaBuscar.id === 'coldtreatment_id' ">
        <ui-select
          label="Valor a Reemplazar :"
          class="w-100 mt-3"
          :keys="{ value: 'id', label: 'name' }"
          placeholder="Seleccione"
          :options="selectColdtreatment"
          v-model="dataValorReemplazar"
        ></ui-select>
      </div>

      <div v-if="dataCampoParaBuscar.id === 'tariff_contract_id'">
        <ui-select
          has-search
          label="Valor a Reemplazar :"
          class="w-100 mt-3"
          :keys="{ value: 'id', label: 'name' }"
          placeholder="Seleccione"
          :options="availableContractsList"
          v-model="dataValorReemplazar">
        </ui-select>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <button
          class="btn btn-outline-success"
          id="buttonRef11"
          @click="filtrarDatos"
        >
          Buscar y Reemplazar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";
// Vuex
import { mapActions, mapState } from "vuex";
// Toast
import VueToastify from "vue-toastify";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
// UI Modal
import UiModal from "keen-ui/src/UiModal";

// Constantes
import { buscarYReemplazar, buscarYRemplazarCount, getContractsByNavId, getListasAcuerdosBase } from "../../../../../constants/lineas";
// Buttom
import Button from "../../../../common/Button";

Vue.use(VueToastify);

export default {
  props: ["addAcuerdoLineasForm","data","getListaAcuerdosLineas", "showBuscarReemplazar"],
  data() {
    return {
      dataCampoParaBuscar: "",
      dataValorCampo: "",
      dataValorReemplazar: "",
      selectedContractsList: [],
      availableContractsList: [],
      selectColdtreatment: [],
      listaCampos: [
        {
          id: "from_date",
          name: "Desde",
        },
        {
          id: "to_date",
          name: "Hasta",
        },
        {
          id: "transit_time",
          name: "TT",
        },
        {
          id: "neta",
          name: "Neta (Costo)",
        },
        {
          id: "public_value",
          name: "Pública (Venta)",
        },
        {
          id: "container_id",
          name: "Unidad",
        },
        {
          id: "products_category_id",
          name: "Commodity",
        },
        {
          id: "atmosphere_id",
          name: "Atmosfera",
        },
        {
          id: "coldtreatment_id",
          name: "ColdTreatment",
        },
        {
          id: "free_days_embark",
          name: "Dias Libres Origen",
        },
        {
          id: "plug_days_embark",
          name: "Dias Plug Origen",
        },
        {
          id: "free_days_land",
          name: "Dias Libres Destino",
        },
        {

          id: "plug_days_land",
          name: "Dias Plug Destino",
        },
        // {
        //   id: "free_days_land",
        //   name: "Dias Libres Origen",
        // },
        // {
        //   id: "plug_days_land",
        //   name: "Dias Plug Origen",
        // },
        // {
        //   id: "free_days_embark",
        //   name: "Dias Libres Destino",
        // },
        // {
        //   id: "plug_days_embark",
        //   name: "Dias Plug Destino",
        // },
                    // "free_days_land" =>  $acuerdosclientebase->diaslibresorigen ,
                    // "plug_days_land" =>  $acuerdosclientebase->diasplugorigen ,
                    // "free_days_embark" =>  $acuerdosclientebase->diaslibresdestino ,
                    // "plug_days_embark" =>  $acuerdosclientebase->diasplugdestino ,
        {
          id: "comment",
          name: "Comentarios",
        },
        {
          id: "tariff_contract_id",
          name: "Contrato",
        },
      ],
    };
  },
  components: {
    UiModal,
    Button,
    DatePicker,
    UiTextbox,
    UiSelect
  },
  computed: {
    ...mapState([
      "contenedores",
      "atmosferas",
      "puertos",
      "showAcuerdoLineas"
    ]),
    ...mapState("lineas", [ "dataListaProducto", "selectCommodities", "selectAtmospheres", "selectContainers", "selectGenset" ]),
  },
  methods: {
    ...mapActions(["ActionSetZindexModal"]),
    async getColdtreatmentList() {
      const { lista_coldtreatment } = await getListasAcuerdosBase();
      this.selectColdtreatment = [{ id: 0, name: "-" }, ...(lista_coldtreatment || [])];
    },
    changeFormatField( ) {
      this.dataValorCampo = "" ;
      this.dataValorReemplazar = "" ;
    },
    showModalValidation(){

      if( this.showAcuerdoLineas ){
        this.openModal('modal');
      }
      else{
        this.$vToastify.warning(
          "Se deben filtrar datos para poder reemplazar.",
          "!Precaución¡"
        );
      }
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    async openModal(ref) {
      this.ActionSetZindexModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef11");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    cerrarModal() {
      this.ActionSetZindexModal(false);
    },
    async filtrarDatos() {

      if( this.data.length === 0 ){
        return this.$vToastify.warning(
          "No hay datos para reemplazar.",
          "Precaución"
        );
      }

      if( this.dataCampoParaBuscar.id === undefined || this.dataCampoParaBuscar.id === ""  ){
        return this.$vToastify.error(
            "Campo en donde Buscar no debe quedar vacío.",
            "¡Error!"
          );
      }

      if( this.dataValorCampo === undefined || this.dataValorCampo === ""  ){
        return this.$vToastify.error(
            "Campo Valor a Buscar no debe quedar vacío.", "¡Error!"
          );
      }

      if( this.dataValorReemplazar === undefined || this.dataValorReemplazar === ""  ){
        return this.$vToastify.error(
            "Campo Valor a reemplazar  no debe quedar vacío.", "¡Error!"
          );
      }

      const ids = this.data.map( d => d.data_complementaria.contrato_id ) ;

      const form = {
        ids,
        field : this.dataCampoParaBuscar.id,
        valorABuscar :  (typeof this.dataValorCampo) === "object" ? this.dataValorCampo.id : this.dataValorCampo,
        valorAReemplazar: (typeof this.dataValorReemplazar) === "object" ? this.dataValorReemplazar.id : this.dataValorReemplazar
      } ;

      this.estadoButton("Realizando Solicitud...");

      try {
        this.$vToastify.loader("Realizando Solicitud...");

        const { data } = await buscarYRemplazarCount( form ) ;
        this.$vToastify.stopLoader();

        if( data.cantidad === 0 ){
          this.estadoButton("Buscar y Reemplazar", false);

          return this.$vToastify.error(
            "No se encontraron registros con los datos ingresados.",
            "¡Error!"
          );
        } else {

          const response = await this.$vToastify.prompt({
            body: `¡Advertencia! \n  ¿Estás seguro que deseas modificar ${data.cantidad} registros?`,
            answers: { Sí: true, No: false },
          });

          if( !response ) return this.estadoButton("Buscar y Reemplazar", false);
        }

      } catch (error) {
        this.estadoButton("Buscar y Reemplazar", false);
        this.$vToastify.stopLoader();
        return ;
      }

      try {
        this.$vToastify.loader("Realizando Solicitud...");

        await buscarYReemplazar( form ) ;

        this.getListaAcuerdosLineas() ;
        this.dataCampoParaBuscar = "" ;
        this.dataValorCampo = "" ;
        this.dataValorReemplazar = "" ;

        this.$vToastify.stopLoader();

        this.$vToastify.success("Se han reemplazado datos con éxito.", "Realizado");

        this.estadoButton("Buscar y Reemplazar", false);
        this.closeModal('modal');

      } catch (error) {
        this.$vToastify.error(
          "Hubo un error al actualizar datos, recargue e intente nuevamente.",
          "¡Error!"
        );
        this.estadoButton("Buscar y Reemplazar", false);
        this.$vToastify.stopLoader();
      }
    },
  },
  watch: {

    dataCampoParaBuscar: function(value) {

      this.selectedContractsList = [];

      this.availableContractsList = [];

      if (value.id === "tariff_contract_id") {

        this.data.forEach(item => {

          let contract = item.data_complementaria.tariff_contract_id;

          let contract_name = contract.name + " - " + contract.number;

          let nav_id = item.data_complementaria.naviera.id;

          const idToInsert = parseInt(contract.id);

          const isIdAlreadyExists = this.selectedContractsList.some(item => parseInt(item.id) === idToInsert);

          if (!isIdAlreadyExists) {

            this.selectedContractsList.push({
              id: idToInsert,
              name: contract_name,
              nav_id: parseInt(nav_id)
            });

          }

        });

      }

    },

    dataValorCampo: async function(value) {

      if (this.dataCampoParaBuscar.id === "tariff_contract_id") {

        this.availableContractsList = await getContractsByNavId({ nav_id: value.nav_id });

      }

    }

  },
  mounted() {
    this.getColdtreatmentList();
  }
};
</script>

<style scoped>
.mx-datepicker{
  margin-left: 0px ;
}
</style>
